<div class="panel-content bg-background gap-3">
    <div class="bg-white rounded-xl py-4 pl-4">
        <div class="flex justify-between items-center">
            <app-field-intervention-title
                (deleteFieldIntervention)="fieldInterventionService.openDeleteModal()"
                (editFieldIntervention)="openFieldInterventionEditionModal()" />
        </div>
        <div class="flex flex-wrap justify-between items-start gap-4 mt-4">
            <div class="flex flex-col sm:flex-row gap-8 flex-1 min-w-[250px] max-w-[calc(100%-240px)]">
                <app-field-intervention-information
                    [contextLayersOptions]="contextLayersOptions()"
                    [contextLayersSelected]="contextLayersSelected()"
                    [description]="fieldInterventionBloc.value()?.description ?? ''"
                    [isFlexRow]="true"
                    [isPlanningDisplay]="true"
                    [showContextLayers]="fieldInterventionPermissionService.canManageFieldIntervention()"
                    (contextLayersSelectionChange)="onContextLayersSelectionChange($event)" />
            </div>
            <div class="flex flex-wrap gap-8 justify-end min-w-[180px] max-w-full pr-4">
                <app-button
                    iconSize="sm"
                    [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                    [icon]="['fas', 'pen']"
                    [label]="'modifySelection' | transloco"
                    [tooltip]="
                        !fieldInterventionPermissionService.canManageFieldIntervention()
                            ? ('insufficientPermissions' | transloco)
                            : undefined
                    "
                    [type]="ButtonType.SECONDARY"
                    (onClick)="goToEntitiesSelectionPage()" />

                <app-button
                    [disabled]="
                        !fieldInterventionPermissionService.canManageFieldIntervention() ||
                        !entitiesTableByLayerService.selectedLayerNumber()
                    "
                    [icon]="['fas', 'timeline-arrow']"
                    [label]="'plan' | transloco"
                    [tooltip]="
                        !fieldInterventionPermissionService.canManageFieldIntervention()
                            ? ('insufficientPermissions' | transloco)
                            : undefined
                    "
                    [type]="ButtonType.PRIMARY"
                    (onClick)="openPlanningModal()" />
            </div>
        </div>
    </div>

    <div class="planning-content">
        <div class="flex-1 h-full">
            <app-tab
                [tabs]="tabs()"
                [translateTabs]="false"
                (changeTab)="changeTab($event)">
                @for (layerName of entitiesTableByLayerService.layerNames(); track layerName) {
                    <ng-template appTabContent>
                        @if (entitiesTableByLayerService.layersByName()) {
                            <div class="flex overflow-y-scroll w-full h-full">
                                <app-field-intervention-entities-list
                                    class="w-full h-full"
                                    [canSelect]="true"
                                    [currentLayers]="entitiesTableByLayerService.layersByName()![layerName]" />
                            </div>
                        }
                    </ng-template>
                } @empty {
                    <ng-template appTabContent>
                        <div class="h-full flex items-center justify-center m-auto">
                            <app-no-data-to-display
                                iconSize="4x"
                                [displayedMessage]="'noFieldInterventionEntity'" />
                        </div>
                    </ng-template>
                }
            </app-tab>
        </div>

        <div class="entities-list-footer-container bg-white py-3 px-2">
            <app-field-intervention-entities-list-footer
                disableReason="entitiesMustBePlanned"
                [activeLayers]="entitiesTableByLayerService.activeLayers()"
                [canExecuteAction]="true"
                [canSearch]="true"
                [disable]="!entitiesTableByLayerService.areEntitiesPlanned()"
                [paginationParameters]="entitiesTableByLayerService.paginationParameters()"
                [primaryButtonProps]="{ labelKey: 'launchIntervention', icon: ['far', 'arrow-right'] }"
                [selectedEntitiesNumber]="entitiesTableByLayerService.selectedEntitiesNumber()"
                [selectedLayerNumber]="entitiesTableByLayerService.selectedLayerNumber()"
                [totalEntities]="fieldInterventionEntitiesListBloc.value()?.totalItems ?? 0"
                (onPrimaryButtonClick)="launchFieldIntervention()"
                (paginator)="onPaginatorChange($event)" />
        </div>
    </div>
</div>
